export const BOOKING_STAGE = 'Booking Fee';
export const OTP_STAGE = '8 Weeks from Option to Purchase';
export const BEFORE_FOUNDATION_STAGE = 'Before Foundation Stage';
export const FOUNDATION_STAGE = 'Foundation Stage';
export const FRAMEWORK_STAGE = 'Reinforced Concrete Framework';
export const WALL_STAGE = 'Wall Stage';
export const CEILING_STAGE = 'Ceiling Stage';
export const WINDOW_STAGE = 'Window Stage';
export const UTILITY_STAGE = 'Electrical Plant, Sanitary Equipment, Air-Conditioning Plant, etc';
export const CAR_PARK_STAGE = 'Car Park Stage';
export const TOP_STAGE = 'Temporary Occupation';
export const CSC_STAGE = 'Legal Completion';

export const BUC_TOTAL_CONSTRUCTION_YEARS = 3;
export const BUC_TOP_PLUS_CSC_DURATIONS = 4; // in months
export const BUC_TOTAL_CONSTRUCTION_MONTHS =
  BUC_TOTAL_CONSTRUCTION_YEARS * 12 + BUC_TOP_PLUS_CSC_DURATIONS;

// must be in the order
export const BUCStage = [
  BEFORE_FOUNDATION_STAGE,
  FOUNDATION_STAGE,
  FRAMEWORK_STAGE,
  WALL_STAGE,
  CEILING_STAGE,
  WINDOW_STAGE,
  UTILITY_STAGE,
  CAR_PARK_STAGE,
  TOP_STAGE,
  CSC_STAGE,
];

// Define Percentage for each stage
export const BUCStagePercent = {
  BOOKING_STAGE: 5,
  OTP_STAGE: 15,
  BEFORE_FOUNDATION_STAGE: 10,
  FOUNDATION_STAGE: 10,
  FRAMEWORK_STAGE: 10,
  WALL_STAGE: 5,
  CEILING_STAGE: 5,
  WINDOW_STAGE: 5,
  UTILITY_STAGE: 5,
  CAR_PARK_STAGE: 5,
  TOP_STAGE: 25,
  CSC_STAGE: 10,
};

// Cumulative BOTTOM-TO-TOP
export const BUCCumulativePercent = {
  BEFORE_FOUNDATION_STAGE: 90,
  FOUNDATION_STAGE: 80,
  FRAMEWORK_STAGE: 70,
  WALL_STAGE: 60,
  CEILING_STAGE: 55,
  WINDOW_STAGE: 50,
  UTILITY_STAGE: 45,
  CAR_PARK_STAGE: 40,
  TOP_STAGE: 35,
  CSC_STAGE: 10,
};

export const BUCStageDuration = {
  BEFORE_FOUNDATION_STAGE: 9,
  FOUNDATION_STAGE: 9,
  FRAMEWORK_STAGE: 8,
  WALL_STAGE: 2,
  CEILING_STAGE: 2,
  WINDOW_STAGE: 2,
  UTILITY_STAGE: 2,
  CAR_PARK_STAGE: 2,
  TOP_STAGE: 3,
  CSC_STAGE: 1,
};

// Cumulative TOP-TO-BOTTOM
export const BUCStageCumulativeDuration = {
  BEFORE_FOUNDATION_STAGE: 9,
  FOUNDATION_STAGE: 18,
  FRAMEWORK_STAGE: 26,
  WALL_STAGE: 28,
  CEILING_STAGE: 30,
  WINDOW_STAGE: 32,
  UTILITY_STAGE: 34,
  CAR_PARK_STAGE: 36,
  TOP_STAGE: 39,
  CSC_STAGE: 40,
};

export const getDurationByStage = (stage: string) => {
  switch (stage) {
    case BEFORE_FOUNDATION_STAGE: {
      return BUCStageDuration.BEFORE_FOUNDATION_STAGE;
    }
    case FOUNDATION_STAGE: {
      return BUCStageDuration.FOUNDATION_STAGE;
    }
    case FRAMEWORK_STAGE: {
      return BUCStageDuration.FRAMEWORK_STAGE;
    }
    case WALL_STAGE: {
      return BUCStageDuration.WALL_STAGE;
    }
    case CEILING_STAGE: {
      return BUCStageDuration.CEILING_STAGE;
    }
    case WINDOW_STAGE: {
      return BUCStageDuration.WINDOW_STAGE;
    }
    case UTILITY_STAGE: {
      return BUCStageDuration.UTILITY_STAGE;
    }
    case CAR_PARK_STAGE: {
      return BUCStageDuration.CAR_PARK_STAGE;
    }
    case TOP_STAGE: {
      return BUCStageDuration.TOP_STAGE;
    }
    case CSC_STAGE: {
      return BUCStageDuration.CSC_STAGE;
    }

    default: {
      return 0;
    }
  }
};

export const getLoanDisburedDurationByStage = (stage: string) => {
  switch (stage) {
    case BEFORE_FOUNDATION_STAGE: {
      return 0;
    }
    case FOUNDATION_STAGE: {
      return BUCStageCumulativeDuration.BEFORE_FOUNDATION_STAGE;
    }
    case FRAMEWORK_STAGE: {
      return BUCStageCumulativeDuration.FOUNDATION_STAGE;
    }
    case WALL_STAGE: {
      return BUCStageCumulativeDuration.FRAMEWORK_STAGE;
    }
    case CEILING_STAGE: {
      return BUCStageCumulativeDuration.WALL_STAGE;
    }
    case WINDOW_STAGE: {
      return BUCStageCumulativeDuration.CEILING_STAGE;
    }
    case UTILITY_STAGE: {
      return BUCStageCumulativeDuration.WINDOW_STAGE;
    }
    case CAR_PARK_STAGE: {
      return BUCStageCumulativeDuration.UTILITY_STAGE;
    }
    case TOP_STAGE: {
      return BUCStageCumulativeDuration.CAR_PARK_STAGE;
    }
    case CSC_STAGE: {
      return BUCStageCumulativeDuration.TOP_STAGE;
    }

    default: {
      return 0;
    }
  }
};

/**
 * Get total construction months if the cumulative loan-to-value is exceeded for the respective stage
 */
export const getLoanDisburedDurationByLTV = (ltv: number) => {
  if (ltv > BUCCumulativePercent.FOUNDATION_STAGE) {
    return 0;
  }

  if (ltv > BUCCumulativePercent.FRAMEWORK_STAGE) {
    return BUCStageCumulativeDuration.BEFORE_FOUNDATION_STAGE;
  }

  if (ltv > BUCCumulativePercent.WALL_STAGE) {
    return BUCStageCumulativeDuration.FOUNDATION_STAGE;
  }

  if (ltv > BUCCumulativePercent.CEILING_STAGE) {
    return BUCStageCumulativeDuration.FRAMEWORK_STAGE;
  }

  if (ltv > BUCCumulativePercent.WINDOW_STAGE) {
    return BUCStageCumulativeDuration.WALL_STAGE;
  }

  if (ltv > BUCCumulativePercent.UTILITY_STAGE) {
    return BUCStageCumulativeDuration.CEILING_STAGE;
  }

  if (ltv > BUCCumulativePercent.CAR_PARK_STAGE) {
    return BUCStageCumulativeDuration.WINDOW_STAGE;
  }

  if (ltv > BUCCumulativePercent.TOP_STAGE) {
    return BUCStageCumulativeDuration.UTILITY_STAGE;
  }

  if (ltv > BUCCumulativePercent.CSC_STAGE) {
    return BUCStageCumulativeDuration.CAR_PARK_STAGE;
  }

  return BUCStageCumulativeDuration.TOP_STAGE;
};

export const getStageNameByMonth = (numberOfMonth: number) => {
  const STARTING_MONTH = 1;

  switch (numberOfMonth) {
    case STARTING_MONTH: {
      return BEFORE_FOUNDATION_STAGE;
    }
    case BUCStageCumulativeDuration.BEFORE_FOUNDATION_STAGE + STARTING_MONTH: {
      return FOUNDATION_STAGE;
    }
    case BUCStageCumulativeDuration.FOUNDATION_STAGE + STARTING_MONTH: {
      return FRAMEWORK_STAGE;
    }
    case BUCStageCumulativeDuration.FRAMEWORK_STAGE + STARTING_MONTH: {
      return WALL_STAGE;
    }
    case BUCStageCumulativeDuration.WALL_STAGE + STARTING_MONTH: {
      return CEILING_STAGE;
    }
    case BUCStageCumulativeDuration.CEILING_STAGE + STARTING_MONTH: {
      return WINDOW_STAGE;
    }
    case BUCStageCumulativeDuration.WINDOW_STAGE + STARTING_MONTH: {
      return UTILITY_STAGE;
    }
    case BUCStageCumulativeDuration.UTILITY_STAGE + STARTING_MONTH: {
      return CAR_PARK_STAGE;
    }
    case BUCStageCumulativeDuration.CAR_PARK_STAGE + STARTING_MONTH: {
      return TOP_STAGE;
    }
    case BUCStageCumulativeDuration.TOP_STAGE + STARTING_MONTH: {
      return CSC_STAGE;
    }

    default: {
      return '';
    }
  }
};

export const getPercentByStage = (stage: string) => {
  switch (stage) {
    case BOOKING_STAGE: {
      return BUCStagePercent.BOOKING_STAGE;
    }
    case OTP_STAGE: {
      return BUCStagePercent.OTP_STAGE;
    }
    case BEFORE_FOUNDATION_STAGE: {
      return BUCStagePercent.BEFORE_FOUNDATION_STAGE;
    }
    case FOUNDATION_STAGE: {
      return BUCStagePercent.FOUNDATION_STAGE;
    }
    case FRAMEWORK_STAGE: {
      return BUCStagePercent.FRAMEWORK_STAGE;
    }
    case WALL_STAGE: {
      return BUCStagePercent.WALL_STAGE;
    }
    case CEILING_STAGE: {
      return BUCStagePercent.CEILING_STAGE;
    }
    case WINDOW_STAGE: {
      return BUCStagePercent.WINDOW_STAGE;
    }
    case UTILITY_STAGE: {
      return BUCStagePercent.UTILITY_STAGE;
    }
    case CAR_PARK_STAGE: {
      return BUCStagePercent.CAR_PARK_STAGE;
    }
    case TOP_STAGE: {
      return BUCStagePercent.TOP_STAGE;
    }
    case CSC_STAGE: {
      return BUCStagePercent.CSC_STAGE;
    }

    default: {
      return 0;
    }
  }
};

export const getCumulativeLoanPercentDisbursedByStage = (ltv: number, stage: string) => {
  switch (stage) {
    case BEFORE_FOUNDATION_STAGE: {
      return ltv > BUCCumulativePercent.FOUNDATION_STAGE
        ? ltv - BUCCumulativePercent.FOUNDATION_STAGE
        : 0;
    }
    case FOUNDATION_STAGE: {
      return ltv > BUCCumulativePercent.FRAMEWORK_STAGE
        ? ltv - BUCCumulativePercent.FRAMEWORK_STAGE
        : 0;
    }
    case FRAMEWORK_STAGE: {
      return ltv > BUCCumulativePercent.WALL_STAGE ? ltv - BUCCumulativePercent.WALL_STAGE : 0;
    }
    case WALL_STAGE: {
      return ltv > BUCCumulativePercent.CEILING_STAGE
        ? ltv - BUCCumulativePercent.CEILING_STAGE
        : 0;
    }
    case CEILING_STAGE: {
      return ltv > BUCCumulativePercent.WINDOW_STAGE ? ltv - BUCCumulativePercent.WINDOW_STAGE : 0;
    }
    case WINDOW_STAGE: {
      return ltv > BUCCumulativePercent.UTILITY_STAGE
        ? ltv - BUCCumulativePercent.UTILITY_STAGE
        : 0;
    }
    case UTILITY_STAGE: {
      return ltv > BUCCumulativePercent.CAR_PARK_STAGE
        ? ltv - BUCCumulativePercent.CAR_PARK_STAGE
        : 0;
    }
    case CAR_PARK_STAGE: {
      return ltv > BUCCumulativePercent.TOP_STAGE ? ltv - BUCCumulativePercent.TOP_STAGE : 0;
    }
    case TOP_STAGE: {
      return ltv > BUCCumulativePercent.CSC_STAGE ? ltv - BUCCumulativePercent.CSC_STAGE : 0;
    }
    case CSC_STAGE: {
      return ltv;
    }

    default: {
      return 0;
    }
  }
};
